<template>
  <div class="question-view flex-fill">
    <div v-html="model.text"></div>

    <div class="flex-fill p-2">
      <media-preview v-if="model.media" v-model="model.media" style="margin:0 auto"/>
    </div>
    
    <div>
      <label>Choices</label>
      <ul>
        <li v-for="c in choices" :key="c.id">
          <div class="p-1">
            <input v-if="model.type == 'checkbox'" v-model="c.is_answer" type="checkbox" disabled="true"/>
            <input v-if="model.type == 'radio'" :checked="c.is_answer" type="radio" disabled="true"/>
            {{ c.label }}
            <media-preview v-if="c.media" v-model="c.media" style="margin-left:1.5rem"/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mediaPreview from '@/components/common/media/media-preview'

export default {
  components:{
    mediaPreview
  },
  props:{
    value: {type:null, default: ''}
  }, 
  computed:{
    choices(){
      return _.sortBy(this.model.choices, ['order'])
    },
    model:{
      get(){ return this.value},
      set(model) { this.$emit('input', model)}
    }
  },
  watch:{
    model(val){
      this.$emit('input', val)
    },
    value(val){
      if(val != this.model){
        this.model = val
      }
    } 
  },
  methods:{
    edit(){
      this.$emit('selected', this.model)
    }, 
    mediaUrl(choice){
      return choice.media.thumbnail ? choice.media.thumbnail.url : choice.media.url
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/questions/view.vue